module.exports = {
    header:{
      index:"home",
      project:"project",
      regional:'regional',
      design:"design",
      brand:'brand',
      rental:"rental",
      footer:"Contact",
      iconTitle:"Business invitation",
    },
      // 项目介绍
      project:{
        project:"Project introduction",
        describe:"DoBe E-manor of Xingguang,DCI (Digital,Culture and Innovation) Hub of Xi'an.Reliant on abundant science and education resources and innovation subject resources in Xi’an\nTaking high technology as the core industry,Taking Smart Circle ecosystem as the operation idea,\nDoBe E-manor of Xingguang gathers the innovative enterprises, and provides the future-oriented smart office experience for the enterprises, and creates the new highland which integrates the scientific & technological innovation and cultural & creative industries.",
        MetroLine2:"地铁二号线",
        belltower:"钟楼",
        XingqingPark:"兴庆公园",
        Pagoda:"大雁塔",
        Happyforestbelt:"幸福林带",
        MetroLine3:"地铁三号线",
        TechnologyUniversity:"西安理工大学",
        JiaotongUniversity:"西安交通大学",
        MetroLine6:"地铁六号线",
        Phase:"二期在建",
        Engineering:"西安工程大学"
      },
      // 区位交通
      regional:{
        regional:"Regional traffic",
        describe:"Surrounded by Dual Metro Lines, Enjoying Convenience and Prosperity\nMain Urban Area of Xi'an, along the Second Ring Road, beside Jiaotong University",
        iconDrive:'Car',
        iconTransit:'Bus',
        iconMetro:'Metro',
        Areabitmap:'Areabitmap',
        describeRing:'East Second Ring',
        describeXiaozhai:"Xiaozhai/Nanshaomen/\nYongningmen/\nZhonglou/Dayanta",
        describeQujiang:"Qujiang/Gaoxin",
        describeRailway:'Xi’an Railway Station',
        describeNorth:"Xi'anbei Railway Statio",
        describeAirport:"Xi'an Xianyang\nInternational Airport",
        transitDescribe:"about 10 bus routes within 500m, reachable to various business districts",
        metroTitle:"Line 3-Yanxingmen station",
        metroDescribe:"Line 6-Gongyuannanlu Station"
      },
      // 设计理念
      design:{
        design:"Design concept",
        TaohuaTitle:"Plenty of flowers in the park\nQuiet triple courtyards Nature all around",
        TaohuaDescribe:"Yard is the poem of a city Official business can be handled in many places while there is a rare opportunity to visit the garden.Pass through the bushy bamboo forests and winding paths.There is scenery everywhere.There is a piece of creative land in the busy downtown area.Make office cozy Perceive life, breeze and warm sunshine in the city",
        receptionTitle:"Urban reception room",
        receptionDescribe:"9m height, step by step,Road show exhibition,social meeting\nCasual switch between business and leisure,Diversified shared space experience.",
        HardcoverTitle:"DoBe SPACE  Enjoy efficient office experience",
        HardcoverDescribe:"DoBe SPACEbelongs to the one-stop office fine decoration service from space design,decoration, and furniture provision to later maintenance, and provides the meeting room,reception area, water bar counter and other shared space facilities,and saves 30% space budgets for the enterprises,and helps the enterprises reduce the operation,business and time costs.",
        wehomeTitle:"wehome space intelligent management platform",
        wehomeDescribe:"Based on DoBe Group’s operating and management experience,as well as mature teams of professionals at our arsenal,we hold fast to independent innovation and combine scientific research with “Internet+” to create the wehome space intelligent management platform and provide a comprehensive intelligent solution to the park and build up a panorama cluster platform, which will ramp up the identification of scenarios and make “intelligent park” come true.",
        commercialTitle:"Starry Street Luxurious & unique lifestyle",
        commercialDescribe:"A one-stop creative commercial block serving white collars and surrounding residents\nFor their work、life、business、social contact、leisure activities"
      },
      // 品牌服务
      brand:{
        brand:"Brand service",
        MembershipTitle:"Comprehensive membership services",
        MembershipDescribe:'Our superior resources support enterprises in their development with such enterprise services as talent management,financial services,branding and promotion,and legal and policy consulting.We take care of any issues our tenants may face in order to grow together.',
        ecosystemTitle:'Light company ecosystem',
        ecosystemDescribe:'DoBe Group connects tenants with one another and with resources inside the park,linking inner and outer circles,upstream and downstream,and cross-border as well.We seamlessly connect thousands of companies and 100,000+professionals to bring about free flows of collaboration among like-minded tenant companies.',
        FederationTitle:'International corporate partnerships',
        FederationDescribe:"DoBe Group covered more than 70 cities in Europe, Asia and Asia. Through this global resource network,the group offers embedded'N+1'international business services,including business registrations abroad,international promotion,commercial cooperation,etc.DoBe Group acts as an 'embassy,' an envoy communicating among its client enterprises to help maximize their economic and social benefits.",
        enterpriseTitle:"Basic business services",
        enterpriseDescribe:"The class 5A intelligent office and property service system provides all customers with professional management and international-standard services,including building management,safety and prevention management,emergency management,and smart operation and services."
      },
      // 租赁信息
      rental:{
        rental:"Rental information",
        Delivery:'Delivery standard:\n rough, fine decoratio',
        totalArea:'Total area of the Project: 15,000㎡',
        DividedArea:'Separable area:\n100-1,000㎡',
        FloorHeight:'Story height:\n 3.5-5m \n(loft decoration partially)',
        ParkingLot:"Parking lot",
        SharedRoom:"Shared Meeting Room",
        conditioning:'VRV',
        Monitoring:'24-hour Security Monitoring Service',
        PublicArea:"WiFi Coverage in Public Area",
        Restaurant:"White collar canteen",
        Garden:"Leisure Park",
        WaterBar:"Water bar",
        viewPlan:"View plan"
      },
      // 底部
      footer:{
        iconTitle:"Business invitation",
        address:"Project address",
        addressDescribe:"Huoju Road, Beilin District, Xi’an",
        position:"Scan code for more information"
      }
}



// WEBPACK FOOTER //
// ./src/assets/lang/en.js